import React from 'react'
import VisibilityOff from '@material-ui/icons/VisibilityOff'

export default function VisibilityOffIcon() {

    return (
        <VisibilityOff />
    )
}